'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

var _videoImage = require('../../../molecules/video-image');

var _videoImage2 = _interopRequireDefault(_videoImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var VideoThumbnail = function (_React$Component) {
  _inherits(VideoThumbnail, _React$Component);

  function VideoThumbnail(props) {
    _classCallCheck(this, VideoThumbnail);

    var _this = _possibleConstructorReturn(this, (VideoThumbnail.__proto__ || Object.getPrototypeOf(VideoThumbnail)).call(this, props));

    _this.renderHeadline = function (headline) {
      if (headline) {
        return _react2.default.createElement(
          _heading2.default,
          { level: '2', className: 'video-thumbnail__headline' },
          htmlToReactParser.parse(headline.text)
        );
      }
      return null;
    };

    _this.renderVideoImage = function (videoImage, properties) {
      if (videoImage) {
        return _react2.default.createElement(_videoImage2.default, _extends({}, videoImage, { name: properties.name, idx: properties.idx }));
      }
      return null;
    };

    _this.renderParagraph = function (paragraph) {
      if (paragraph && paragraph.text) {
        return _react2.default.createElement(
          'p',
          { className: 'video-thumbnail__paragraph' },
          htmlToReactParser.parse(paragraph.text)
        );
      }
      return null;
    };

    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.state = {
      showImages: false
    };
    return _this;
  }

  _createClass(VideoThumbnail, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var domRect = this.sectionElement && this.sectionElement.getBoundingClientRect();
      if (domRect && window.innerHeight - domRect.top >= 0) {
        this.enableImages();
        return;
      }
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'enableImages',
    value: function enableImages() {
      this.setState({
        showImages: true
      });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      window.removeEventListener('scroll', this.handleScroll);
      this.enableImages();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          config = _props.config,
          content = _props.content,
          className = _props.className;
      var showImages = this.state.showImages;
      var id = config.id;
      var headline = content.headline,
          videoImage = content.videoImage,
          paragraph = content.paragraph;


      var VideoThumbnailClasses = (0, _classnames2.default)('video-thumbnail', className);

      return _react2.default.createElement(
        'section',
        {
          className: VideoThumbnailClasses,
          id: id,
          'data-building-block': 'organism',
          ref: function ref(el) {
            _this2.sectionElement = el;
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-md-6 video-thumbnail__container text-md-left text-xs-center' },
              this.renderHeadline(headline),
              this.renderParagraph(paragraph)
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'col-xs-12 col-md-6 video-thumbnail__container video-thumbnail__device-image text-xs-center'
              },
              showImages ? this.renderVideoImage(videoImage, this.props) : null
            )
          )
        )
      );
    }
  }]);

  return VideoThumbnail;
}(_react2.default.Component);

exports.default = VideoThumbnail;


VideoThumbnail.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    videoImage: _videoImage2.default.propTypes.isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  }),
  name: _propTypes2.default.string,
  idx: _propTypes2.default.number,
  className: _propTypes2.default.string
};

VideoThumbnail.defaultProps = {
  config: {
    id: ''
  },
  content: {
    videoImage: _videoImage2.default.defaultProps,
    paragraph: {
      text: '146 characters maximum per paragraph to not equal ' + 'more than 5 lines of copy on mobile devices.'
    },
    headline: {
      text: '34 characters maximum'
    }
  },
  name: 'VideoThumbnail',
  idx: 0,
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/video-thumbnail/jsx/VideoThumbnail.js
// module id = 1158
// module chunks = 4